/**
 * The identifier of the sound to be played when we display a you are noisy notification.
 *
 * @type {string}
 */
export const NOISY_AUDIO_INPUT_SOUND_ID = 'NOISY_AUDIO_INPUT_SOUND';
